<template>
  <div
    :id="questionId"
    :type="attributeType"
    class="questionModel"
    @clearValue="clearValue()"
    @disableInput="disableInput()"
    @enableInput="enableInput()"
    @enableRequired="enableRequired()"
    @percentageValidationFailed="percentageValidationFailed()"
    @percentageValidationSuccess="percentageValidationSuccess()"
    @removeRequired="removeRequired()"
  >
    <b-col>
      <label class="questionLabelStyle"
        ><span v-if="requiredStar" class="requiredStar">* </span>{{ label }}</label
      >
      <div v-if="helpText">
        <p class="helpTextStyle"><span v-html="helpText"></span></p>
      </div>
    </b-col>
    <b-col>
      <b-table-simple
        :id="questionId + '_value'"
        :no-border-collapse="true"
        :sticky-header="'800px'"
        bordered
        class="w-100"
      >
        <b-thead>
          <b-tr height="66 px">
            <b-th
              v-for="question in childOfListQuestions"
              :key="question.Id"
              class="mx-0 text-center align-middle p-0"
              style="background-color: #01004e;"
            >
              <b-col><label class="textHeadStyle" v-html="question.Label__c"></label></b-col>
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td v-for="question in childOfListQuestions" :key="question.Id" class="p-0">
              <component
                :is="question['Attribute_Type__c']"
                :key="question.Id"
                :answer="listAnswers[question.Id]"
                :attributeType="question['Attribute_Type__c']"
                :helpText="question['Help_Text__c']"
                :label="question.Label__c"
                :name="question.Name"
                :options="listOptions[question.Id]"
                :questionId="question.Id"
                :requiredQuestions="requiredQuestions"
                :staticListCount="staticListCount"
                :staticListQuestionId="questionId"
                :validationsType="validationsType"
                @input="
                  updateForm(
                    objectId + '_' + question.Id + '_Static' + question['Attribute_Type__c'],
                    $event,
                  )
                "
              >
              </component>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <validation-observer ref="observer">
        <validation-provider
          ref="provider"
          v-slot="validationContext"
          :rules="`${isValidPercentage ? 'isValidPercentage' : ''}${isRequired ? '|required' : ''}`"
          name="staticList"
        >
          <b-form-input
            :id="questionId + '_value'"
            ref="staticList"
            v-model="staticListValue"
            :state="getValidationState(validationContext)"
            aria-describedby="validationFeedback"
            hidden
          />

          <b-form-invalid-feedback
            id="validationFeedback"
            class="font-weight-bold text-right"
            style="font-size: 18px"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </validation-observer>
    </b-col>
  </div>
</template>
<script>
  import { extend } from 'vee-validate';
  import StaticColumn from './StaticListComponents/StaticColumn';
  import Picklist from './StaticListComponents/StaticPicklist';
  import Textbox from './StaticListComponents/StaticTextBox';
  import Percentage from './StaticListComponents/StaticPercentage';
  import Date from './StaticListComponents/StaticDate';
  import Number from './StaticListComponents/StaticNumber';

  extend('isValidPercentage', state => {
    return state === 'isValid';
  });

  export default {
    name: 'StaticList',
    components: {
      StaticColumn,
      Picklist,
      Textbox,
      Percentage,
      Date,
      Number,
    },
    data() {
      return {
        formData: {},
        isValidPercentage: false,
        isRequired: false,
        staticListValue: 'nothing',
        requiredStar: false,
      };
    },
    props: [
      'dependentQuestion',
      'requiredQuestions',
      'label',
      'attributeType',
      'name',
      'answer',
      'questionId',
      'listLovs',
      'objectId',
      'listAnswers',
      'staticListCount',
      'options',
      'childOfListQuestions',
      'listAnswers',
      'listOptions',
      'helpText',
      'validationsType',
    ],
    created() {
      if (this.requiredQuestions.includes(this.questionId)) {
        this.isRequired = true;
        this.requiredStar = true;
      }
      this.childOfListQuestions.forEach(element => {
        if (element['Attribute_Type__c'] === 'Percentage') {
          this.isRequired = true;
          this.isValidPercentage = true;
          this.$emit('staticPercentageValidation', { id: this.questionId, status: 'enable' });
        }
      });
    },
    methods: {
      getValidationState({ dirty, validated, valid = null, required }) {
        if (required) {
          return dirty || validated ? valid : null;
        }
      },
      disableInput() {
        let count = this.staticListCount;
        this.childOfListQuestions.forEach(childElement => {
          for (let i = 0; i < count; i++) {
            let idx = i + 1;
            document
              .getElementById(childElement.Id + '_value_' + idx)
              .setAttribute('hideElement', 'true');
          }
        });
        document.getElementById(this.questionId).classList.add('hideElement', 'pl-5');
      },
      enableInput() {
        let count = this.staticListCount;
        this.childOfListQuestions.forEach(childElement => {
          for (let i = 0; i < count; i++) {
            let idx = i + 1;
            let component = document.getElementById(childElement.Id).classList;
            if (!component.contains('hideElement')) {
              document
                .getElementById(childElement.Id + '_value_' + idx)
                .removeAttribute('hideElement');
            }
          }
        });
        document.getElementById(this.questionId).classList.remove('hideElement');
      },
      clearValue() {
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
        this.childOfListQuestions.forEach(childElement => {
          document.getElementById(childElement.Id).dispatchEvent(new Event('clearValue'));
        });
      },
      percentageValidationSuccess() {
        this.staticListValue = 'isValid';
      },
      percentageValidationFailed() {
        this.staticListValue = 'isInvalid';
      },
      updateForm(fieldName, value) {
        this.$set(this.formData, fieldName, value);
        this.$emit('input', this.formData);
      },
      removeRequired() {
        this.requiredStar = false;
        this.isRequired = false;
        this.isValidPercentage = false;
        this.$emit('staticPercentageValidation', { id: this.questionId, status: 'remove' });
      },
      enableRequired() {
        if (this.requiredQuestions.includes(this.questionId)) {
          this.requiredStar = true;
          this.isRequired = true;
        }
        this.childOfListQuestions.forEach(element => {
          if (element['Attribute_Type__c'] === 'Percentage') {
            this.isRequired = true;
            this.isValidPercentage = true;
            this.$emit('staticPercentageValidation', { id: this.questionId, status: 'enable' });
          }
        });
      },
    },
  };
</script>
<style scoped>
  .headColor {
    background-color: #01004e;
  }
  .textHeadStyle {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #fcfcfc;
  }
</style>
